<template>
  <van-nav-bar
  title="修改价格"
  left-arrow
  @click-left="onGoBack"
  />
  <div>
    <van-cell-group class="group" title="选择人员" border=true>
    <van-search
  v-model="value"
  shape="round"
  placeholder="搜索人员"
  @update:model-value="getoperuserinfo"
  >
  </van-search>
  <div v-if="is_data">
  <van-cell v-for="item in userlist.data" :key="item"  is-link @click="getuserinfo(item)">
    <span style="margin-left:20px" @click="aa">{{item.user_name}}({{item.user_phone_num}})</span>
  </van-cell>
  </div>
  </van-cell-group>
  </div>
  <van-cell-group title="选择价格" border=true>
  
  <van-radio-group v-model="priceradio">
  <van-cell-group inset>
    <van-cell title="220" clickable @click="priceradio = 'oagZSP'">
      <template #right-icon>
        <van-radio name="oagZSP" checked-color="#ee0a24"/>
      </template>
    </van-cell>
    <van-cell title="190" clickable @click="priceradio = 'WjH0ig'">
      <template #right-icon>
        <van-radio name="WjH0ig"  checked-color="#ee0a24"/>
      </template>
    </van-cell>
    <van-cell title="160" clickable @click="priceradio = 'JFepkj'">
      <template #right-icon>
        <van-radio name="JFepkj" checked-color="#ee0a24"/>
      </template>
    </van-cell>
    <van-cell title="135" clickable @click="priceradio = 'hzslWg'">
      <template #right-icon>
        <van-radio name="hzslWg" checked-color="#ee0a24"/>
      </template>
    </van-cell>
    <van-cell title="115" clickable @click="priceradio = 'HeXsng'">
      <template #right-icon>
        <van-radio name="HeXsng" checked-color="#ee0a24"/>
      </template>
    </van-cell>
  </van-cell-group>
</van-radio-group>
</van-cell-group>
  <van-button :disabled='isdisable' :loading='isloading'  type="success" class='bottombutton' block @click="OnChangePrice">确认修改</van-button>
 
</template>

<script>
import { ref,reactive,getCurrentInstance} from 'vue';
import { useUserStore } from '@/store/user.ts'
import { Picker } from 'vant';
import { Popup } from 'vant';
import {Toast} from 'vant';
const userStore=useUserStore()
export default {
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Picker.Toast]: Toast,
  },

  setup() {
    const is_data = ref(false);
    let userlist= reactive({
      data: [{}]
    });
    const value = ref('');
    const priceradio=ref('oagZSP')
    const userid=ref()

    let { proxy } = getCurrentInstance();
    const getoperuserinfo=()=>{
      let params = {data: {}}
      params={'queryName':value.value}
      //proxy.$axios.post(process.env.VUE_APP_API_PORT_BASE_URL+'/user/getUser',params)
      let tokens={'Authorization':userStore.userInfo.token}
      proxy.$axios.post(process.env.VUE_APP_API_PORT_BASE_URL+'/user/getAllUserPartner',params,{headers:tokens})
      .then(res=>{
        userlist.data.length=0;
        for (var i=0;i<res.data.data.length;i++){
          console.log(res.data.data[i])
          userlist.data.push(res.data.data[i])
        }
        is_data.value=true
      })
    };

    const getuserinfo=(item)=>{
      console.log(item.id)
      userid.value=item.id;
      value.value=item.user_name+'（'+item.user_phone_num+'）';
      is_data.value=false
    };

    const OnChangePrice=()=>{
      let params = {data: {}}
      params={
              "id" :userid.value,
              "randomCode":priceradio.value
            }
      let tokens={'Authorization':userStore.userInfo.token}
      proxy.$axios.post(process.env.VUE_APP_API_PORT_BASE_URL+'/user/modifyUserRandomCode',params,{headers:tokens})
      .then(res=>{
        Toast(res.data.msg)
      })
    }

    return {
      priceradio,
      is_data,
      value,
      userid,
      userlist,
      getoperuserinfo,
      getuserinfo,
      OnChangePrice,
    };
  }
  
};
</script>

<style lang="less">

.edit-icon {
    font-size: 16px;
    line-height: inherit;
  }

</style>
